// extracted by mini-css-extract-plugin
export default {"homeWrapper":"Home_homeWrapper__v4vD8","card":"Home_card__t7Ij8","errorText":"Home_errorText__jkkYn","modalSubtitle":"Home_modalSubtitle__DPea+"};